import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import type { AdminSport, UpdateSportConfigRequest } from '@/api/types';

export function useAdminSports() {
  return useQuery({
    queryKey: ['adminSports'],
    queryFn: () => apiClient<AdminSport[]>('/admin/sports'),
  });
}

export function useUpdateSportConfig() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ sportCode, ...request }: UpdateSportConfigRequest & { sportCode: string }) =>
      apiClient<AdminSport>(`/admin/sports/${sportCode}`, {
        method: 'PUT',
        body: JSON.stringify(request),
      }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['adminSports'] });
    },
  });
}

export function useUpdateLocationSportConfig() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ locationId, sportCode, config }: { locationId: string; sportCode: string; config: Record<string, unknown> }) =>
      apiClient<void>(`/admin/sports/locations/${locationId}/${sportCode}/config`, {
        method: 'PUT',
        body: JSON.stringify(config),
      }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['adminSports'] });
      qc.invalidateQueries({ queryKey: ['locationSports'] });
    },
  });
}

export function useToggleSportAtLocation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ locationId, sportCode, enabled }: { locationId: string; sportCode: string; enabled: boolean }) =>
      apiClient<void>(`/admin/sports/locations/${locationId}/${sportCode}/toggle`, {
        method: 'PUT',
        body: JSON.stringify({ enabled }),
      }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['adminSports'] });
      qc.invalidateQueries({ queryKey: ['locationSports'] });
    },
  });
}
